import { render, staticRenderFns } from "./LatestBlog.vue?vue&type=template&id=696a2c84&scoped=true&lang=pug&"
import script from "./LatestBlog.vue?vue&type=script&lang=js&"
export * from "./LatestBlog.vue?vue&type=script&lang=js&"
import style0 from "./LatestBlog.vue?vue&type=style&index=0&id=696a2c84&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "696a2c84",
  null
  
)

export default component.exports